import { render, staticRenderFns } from "./LpuSpecialityListOptions.vue?vue&type=template&id=e7ff3acc&scoped=true&"
import script from "./LpuSpecialityListOptions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuSpecialityListOptions.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuSpecialityListOptions.vue?vue&type=style&index=0&id=e7ff3acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ff3acc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7ff3acc')) {
      api.createRecord('e7ff3acc', component.options)
    } else {
      api.reload('e7ff3acc', component.options)
    }
    module.hot.accept("./LpuSpecialityListOptions.vue?vue&type=template&id=e7ff3acc&scoped=true&", function () {
      api.rerender('e7ff3acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/LpuSpecialityList/components/common/LpuSpecialityListOptions.vue"
export default component.exports